<template>
  <div class="p_post_content">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead/>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>系统</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/roles' }">角色管理</el-breadcrumb-item>
                <el-breadcrumb-item>编辑角色</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_post_form" v-loading="tableLoading">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="角色名称" prop="rolename">
              <el-input v-model="ruleForm.rolename" clearable></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="StrRemark">
              <el-input v-model="ruleForm.StrRemark" type="textarea" clearable></el-input>
          </el-form-item>
          <el-form-item label="配置权限" prop="roleList">
            <!-- :default-checked-keys="ruleForm.roleList" 去除父级节点 -->
            <div class="treeBox">
              <el-tree
                ref="tree"
                node-key="powercode"
                show-checkbox
                :data="powerList"
                :props="defaultProps"
                highlight-current
                :default-expanded-keys="['1c895257-a000-d000-b000-adb6df000001','1c895257-a000-d000-b001-adb6df000001']"
                :expand-on-click-node="false"
                @check-change="handleNodeClick">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <!-- 一级菜单图标 -->
                    <span v-if="data.strbanded == 1" class="el-icon-folder-opened"></span>
                    <!-- 二级菜单图标 -->
                    <span v-else-if="data.strbanded == 2&& !isNull(data.children)" class="el-icon-folder-opened"></span>
                    <span v-else-if="data.strbanded == 2&& isNull(data.children)" class="el-icon-folder"></span>
                    <!-- 按钮图标 -->
                    <span v-else-if="data.strbanded == 4" class="el-icon-setting"></span>
                    <span v-else class="el-icon-folder" style="margin-right: 3px"></span>
                    <span>{{ node.label }}</span>
                  </span>
              </el-tree>
            </div>
          </el-form-item>
          <el-form-item label="">
              <el-button @click="backHandle">取消</el-button>
              <el-button :loading="btnloading" type="primary" @click="submitForm('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
export default {
  name: "updatePost",
  data() {
    return {
        // 参数
        ruleForm:{
            roletype:'test', // 角色标识
            rolename:'',//角色名称
            roleList:[],// 选中的配置权限
            StrRemark:'' // 备注
        },
        btnloading:false,
        rules: {
          rolename: [
            { required: true, message: '请输入角色名称', trigger: 'blur' }
          ],
          roleList: [
            { type: 'array', required: true, message: '请选择配置权限', trigger: 'change' }
          ]
        },
        // 编辑时角色对应选中的配置权限
        checkedList:[],
        defaultProps: {  //组件必须的参数，children和label是组件固定结构，若绑定的数据名字不同，直接赋值即可
            children:'children',    
            label:'powername'
        },
        tableLoading:false,
        powerList: [],
        //取权限菜单参数
        roleQuery:{
          roletype:'', // 根据角色传
          stationid:'',//根据岗位
          roleuserid:'' // 根据员工id(三个都不传为所有菜单 按钮权限)
        }
    }
  },
  created() {
    let roleName = this.$route.query.RoleName
    // console.log('ff', roletypes)
    if(!this.isNull(roleName)){
        this.ruleForm.roletype = this.$route.query.roletype
        this.roleQuery.roletype = this.$route.query.roletype
        this.ruleForm.rolename = this.$route.query.RoleName
        this.ruleForm.StrRemark = this.$route.query.StrRemark
    }
    this.getRoleList()
  },
  methods: {
    // 保存
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnloading = true
          // console.log('角色', this.ruleForm)
          let powerlist = that.ruleForm.roleList.toString()
          xz.bupdateauthRoleList(that.ruleForm,powerlist).then(res => {
            // console.log('角色', res)
            if (res.status == 'ok') {
              that.$message({
                type: 'success',
                message: '操作成功！',
                center: true,
                duration: 2000
              });
              that.$router.push({
                path: "/roles",
              });
            } else {
              that.$message({
                type: 'error',
                message: '操作失败，请稍后再试！',
                center: true,
                duration: 2000
              });
            }
            this.btnloading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 节点选中状态发生变化时的回调
    handleNodeClick(data, checked, indeterminate){
      // console.log('handleNodeClick',data)
      this.ruleForm.roleList = []
      //获取所有选中的节点 start
      let checkKeys = this.$refs.tree.getCheckedKeys()
      let checkHAlfKeys = this.$refs.tree.getHalfCheckedKeys()
      // let res = this.$refs.tree.getCheckedNodes()
      // console.log('res',checkKeys,checkHAlfKeys)
      this.ruleForm.roleList = checkKeys.concat(checkHAlfKeys)
      // let arrDeptId = []
      // res.forEach((item) => {
      //     arrDeptId.push(item.id)
      // })
    },
    // 取消
    backHandle(){
      this.$router.push({
          path: "/roles",
      });
    },
    // 遍历递归--获取选中的节点
    generaNode(ele, data){
      let that = this
      data.forEach(item => {
        if (!that.isNull(item.children)) {
          that.generaNode(ele, item.children)
        }
        if(item.isused == '1'){
          ele.push(item.powercode)
        }
      })
    },
    // 获取所有权限菜单(通用)
    getRoleList(){
      this.tableLoading = true
      this.checkedList = []
      this.ruleForm.roleList = []
      let that = this
      // this.roleQuery.roletype = ''
      xz.baLLGetauthPowerInf(this.roleQuery).then(res => {
        // console.log('权限菜单', res)
        if (res.status == 'ok') {
          that.powerList = res.msg.parent
          let allList = res.msg.parent
          // 获取默认所有选中的节点--包含父节点
          that.generaNode(that.ruleForm.roleList, allList)
          // 回显默认所有选中的节点--不包含父节点
          that.$nextTick(() => {
            that.ruleForm.roleList.forEach(f => {
              //为了解决父级没有全选中（只选中某个子级）但是数据存在父级id然后回显选中问题
              if (!that.$refs.tree.getNode(f).childNodes || !that.$refs.tree.getNode(f).childNodes.length) {
                that.checkedList.push(f)
              }
            });
            that.$refs.tree.setCheckedKeys(that.checkedList);
          })
          // console.log('checkedList', that.checkedList)
        } else {
          that.powerList = []
        }
        that.tableLoading = false
      })
    },
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN'
    }
  }
}
</script>
<style scoped>
.p_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.p_post_form{
    background-color: #fff;
    padding: 15px 10px;
}
.treeBox{
    width: 600px;
    max-height: 450px;
    min-height: 30px;
    overflow-y: auto;
    border:1px solid #DCDFE6;
    padding-left: 15px;
    box-sizing: border-box;
}
</style>
<style>
.p_post_content .p_post_form .el-form-item__label{
    color:#000;
}
.p_post_content .p_post_form .el-input,.p_post_content .p_post_form .el-textarea{
    width: 600px;
}
.p_post_content .p_post_form label.el-checkbox{
    display: block;
}
</style>